module.exports = __webpack_public_path__ + "img/achievement_32.d78e1ed5.png";